(function () {

    'use strict';

    angular.module('iplusjs.asyncValidator', [])
        .directive('iplusjsAsyncValidator', asyncValidator);

    asyncValidator.$inject = [];
    function asyncValidator() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, $elem, $attrs, ngModelCtrl) {
                var validatorName = $attrs.iplusjsAsyncValidator,
                    validation = $scope.$eval($attrs.iavValidation);

                if (!validatorName || !validation) {
                    return;
                }

                ngModelCtrl.$asyncValidators[validatorName] = validation;
            }
        };
    }
})();
